module.exports = __webpack_public_path__ + "static/media/student-summary-back.104e7eb9.png";